import { baseApiRequest } from "../baseApiRequest";
import { errorifInvalidPin } from "../../pinUtils";

const origin = process.env.REACT_APP_API_ORIGIN ?? ''

export async function pinMutationFunction<TResponse, TRequestBody>(body: TRequestBody, method: 'POST' | 'PUT' | 'DELETE', path: string, pin: string | null) {
  errorifInvalidPin(pin)
  const url = `${origin}/api/${path}`

  return baseApiRequest<TResponse>({
    url,
    init: {
      method,
      headers: {
        Authorization: `Bearer ${pin}`,
        'Content-Type': 'application/json',
      },
      body: body ? JSON.stringify(body) : undefined,
    },
    trackingEvent: 'usePinApiMutation',
  })
}
